<app-install-banner />
<app-update-banner />
<router-outlet />
<app-chat-bubble />
